import PropTypes from "prop-types";
import * as AriaKit from "@ariakit/react";

const TEXT_COLOR = "#FFF";
const BACKGROUND_COLOR = "#333";

const InfotipContent = ({ children, label, ...rest }) => {
  const cssStyles = {
    maxWidth: "300px",
    padding: "8px",
    borderRadius: "4px",
    fontSize: "0.9rem",
    backgroundColor: BACKGROUND_COLOR,
    color: TEXT_COLOR,
  };
  return (
    <AriaKit.TooltipProvider>
      <AriaKit.TooltipAnchor
        as={"span"}
        className="tooltip-anchor"
        render={children}
      />
      <AriaKit.Tooltip
        id={undefined}
        ariaLabelledBy={undefined}
        className="tooltip-content"
        style={cssStyles}
        {...rest}
      >
        {label}
      </AriaKit.Tooltip>
    </AriaKit.TooltipProvider>
  );
};

InfotipContent.propTypes = {
  children: PropTypes.node.isRequired,
  label: PropTypes.node.isRequired,
  id: PropTypes.node.isRequired,
};

export default InfotipContent;
